import api from './api';

const notificationService = {
  list(params = {}) {
    return api.get('/notifications/', { params });
  },

  markRead(id) {
    return api.post(`/notifications/${id}/mark-read/`);
  },

  markAllRead() {
    return api.post('/notifications/mark-all-read/');
  },

  unreadCount() {
    return api.get('/notifications/unread-count/');
  },

  delete(id) {
    return api.delete(`/notifications/${id}/`);
  },
};

export { notificationService };
export default notificationService;
